import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "books__icons"
}
const _hoisted_2 = { class: "books__text-box" }
const _hoisted_3 = { class: "books__text" }
const _hoisted_4 = { class: "books__upper-box" }
const _hoisted_5 = {
  key: 0,
  class: "books__wrapper"
}
const _hoisted_6 = { class: "books__category card__category" }
const _hoisted_7 = { class: "books__title card__title" }
const _hoisted_8 = { class: "books__author card__author" }
const _hoisted_9 = { class: "books__lower-box" }
const _hoisted_10 = { class: "books__info" }

import { computed } from 'vue'

import DocBadges from '@/app/components/doc/DocBadges.vue'
import DocListsMenu from '@/app/components/doc/DocListsMenu.vue'
import DocMoreMenu from '@/app/components/doc/DocMoreMenu.vue'
import DocProgressBar from '@/app/components/doc/DocProgressBar.vue'
import DocTypeBadge from '@/app/components/doc/DocTypeBadge.vue'
import SaveButton from '@/app/components/doc/SaveButton.vue'
import TimeEstimate from '@/app/components/doc/TimeEstimate.vue'
import BookListenIcon from '@/app/components/book/card/BookListenIcon.vue'
import FreeBookIcon from '@/app/components/book/card/FreeBookIcon.vue'
import BookCardThumbnail from '@/app/components/book/card/BookCardThumbnail.vue'
import DocLibraryMenu from '@/app/components/doc/DocLibraryMenu.vue'
import CustomListDocMenu from '@/app/components/custom.lists/CustomListDocMenu.vue'
import { saveForLater20321Treatment } from '@/services/ab/experiments'

import type { BookListItem, CustomList } from '@/models/interfaces'
import type { BooksView } from '@/models/doc.book'


export default /*@__PURE__*/_defineComponent({
  __name: 'BookCard',
  props: {
    doc: {},
    view: {},
    showFreeBooks: { type: Boolean, default: true },
    customList: {}
  },
  setup(__props: any) {

const props = __props

const showNewSaveDesign = saveForLater20321Treatment()

const isCTA = computed(() => {
  return props.doc.title === 'CTA'
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!isCTA.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["books__item", [__props.doc.id, { 'books__item--20321B': _unref(showNewSaveDesign) }]])
      }, [
        (_unref(showNewSaveDesign) && __props.view.hasUserData(__props.doc))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(SaveButton, {
                class: "books__save-button",
                doc: __props.doc,
                docsView: __props.view
              }, null, 8, ["doc", "docsView"]),
              _createVNode(DocMoreMenu, {
                class: _normalizeClass(["books__more-menu", { 'books__more-menu--above-progress': __props.doc.user?.progress }]),
                doc: __props.doc,
                docsView: __props.view
              }, null, 8, ["class", "doc", "docsView"])
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          to: __props.view.startLinkParams(__props.doc),
          class: "books__link"
        }, {
          default: _withCtx(() => [
            (_unref(showNewSaveDesign))
              ? (_openBlock(), _createBlock(DocTypeBadge, {
                  key: 0,
                  docType: "book"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  (__props.doc.has_audio)
                    ? (_openBlock(), _createBlock(BookListenIcon, { key: 0 }))
                    : _createCommentVNode("", true),
                  (__props.doc.is_free && __props.showFreeBooks)
                    ? (_openBlock(), _createBlock(FreeBookIcon, { key: 1 }))
                    : _createCommentVNode("", true)
                ])),
            _createVNode(BookCardThumbnail, {
              class: "books__img-box",
              coverClass: "books__img",
              fallbackCoverClass: "books__img",
              doc: __props.doc,
              cacheBust: true
            }, null, 8, ["doc"]),
            _createVNode(DocProgressBar, {
              class: "books__progress",
              progress: __props.doc.user?.progress
            }, null, 8, ["progress"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (!_unref(showNewSaveDesign))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("h5", _hoisted_6, _toDisplayString(__props.view.firstTag(__props.doc)), 1),
                        (__props.view.hasUserData(__props.doc) && __props.doc.user.custom_lists)
                          ? (_openBlock(), _createBlock(DocListsMenu, {
                              key: 0,
                              doc: __props.doc,
                              docsView: __props.view
                            }, null, 8, ["doc", "docsView"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("h3", _hoisted_7, _toDisplayString(__props.doc.title), 1),
                  _createElementVNode("h4", _hoisted_8, _toDisplayString(_unref(showNewSaveDesign) ? __props.doc.author : `By ${__props.doc.author}`), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (_unref(showNewSaveDesign))
                      ? (_openBlock(), _createBlock(DocBadges, {
                          key: 0,
                          doc: __props.doc,
                          free: __props.doc.is_free && __props.showFreeBooks
                        }, null, 8, ["doc", "free"]))
                      : (_openBlock(), _createBlock(TimeEstimate, {
                          key: 1,
                          doc: __props.doc
                        }, null, 8, ["doc"]))
                  ]),
                  (__props.doc.user?.progress)
                    ? (_openBlock(), _createBlock(DocProgressBar, {
                        key: 0,
                        class: _normalizeClass(["books__progress--mobile", {
                'books__progress--rightmenu':
                  !_unref(showNewSaveDesign) && __props.view.showActionsButton(__props.doc),
              }]),
                        progress: __props.doc.user.progress
                      }, null, 8, ["class", "progress"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (!_unref(showNewSaveDesign))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (
              __props.view.showActionsButton(__props.doc) &&
              __props.customList?.doc_type === 'custom_list'
            )
                      ? (_openBlock(), _createBlock(CustomListDocMenu, {
                          key: 0,
                          class: "books__actions books__actions--list-page",
                          doc: __props.doc,
                          docsView: __props.view,
                          list: __props.customList,
                          position: "right"
                        }, null, 8, ["doc", "docsView", "list"]))
                      : (__props.view.showActionsButton(__props.doc))
                        ? (_openBlock(), _createBlock(DocLibraryMenu, {
                            key: 1,
                            class: "books__actions books__actions--library",
                            doc: __props.doc,
                            docsView: __props.view,
                            position: "right"
                          }, null, 8, ["doc", "docsView"]))
                        : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["to"])
      ], 2))
    : _createCommentVNode("", true)
}
}

})